import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: [],
};

const statusModalSlice = createSlice({
  name: "statusModal",
  initialState,
  reducers: {
    showModal: (state, action) => {
      // const isDuplicate = state.modals.some(
      //   (modal) => modal.message === action.payload.message
      // );

      // if (!isDuplicate) {
      state.modals.push({
        id: Date.now(),
        message: action.payload.message,
        status: action.payload.status,
      });
      // }
    },
    hideModal: (state, action) => {
      state.modals = state.modals.filter(
        (item) => item.id !== action.payload.id
      );
    },
  },
});

export const { showModal, hideModal } = statusModalSlice.actions;

export default statusModalSlice.reducer;
